import { render } from "./Doel.vue?vue&type=template&id=ef673bb4&scoped=true"
import script from "./Doel.vue?vue&type=script&lang=js"
export * from "./Doel.vue?vue&type=script&lang=js"

import "./Doel.vue?vue&type=style&index=0&id=ef673bb4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef673bb4"]])

export default __exports__